import { withInstall } from '@haohan/clw-utils'
import PreviewLayout from './index.vue'
export const HHPreviewLayout = withInstall(PreviewLayout)
export default HHPreviewLayout
